import * as React from "react";
import Box from "@mui/material/Box";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import { visuallyHidden } from "@mui/utils";
import { DataTableCell, DataTableHeadProps } from "./dataTable.interface";

export default function DataTableHead(props: DataTableHeadProps) {
  const {
    order,
    orderBy,
    onRequestSort,
    headCells,
    headCellFontSize = "13px",
  } = props;

  const createSortHandler =
    (property: keyof DataTableCell) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property);
    };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            padding="normal"
            sortDirection={orderBy === headCell.id ? order : false}
            style={{
              width: headCell.width,
              fontWeight: 700,
              fontSize: headCellFontSize,
              textAlign: headCell.align
                ? headCell.align
                : headCell.isSortable
                  ? "left"
                  : "right",
              ...(headCell?.cellStyles || {}),
            }}
          >
            {React.isValidElement(headCell.label) ? (
              headCell.label // Directly render the JSX element
            ) : headCell.isSortable ? (
              <TableSortLabel
                sx={{ fontWeight: 700 }}
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
                className="font-bold"
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box
                    className="font-bold"
                    component="span"
                    sx={visuallyHidden}
                  >
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            ) : (
              <Box className="font-bold" component="span">
                {headCell.label}
              </Box>
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
